import React from "react";
import {
  Title,
  P,
  ListMain,
  ListSec,
  LiTitle,
  LiTextBold,
  TextWithOpacity,
} from "./style";
import { TermsContainer } from "../../../CommonStyles";

const PolicyTermsHeb = () => {
  return (
    <TermsContainer style={{height: '270px'}} lngDirection="heb">
      <Title>תקנון אתר זיכרון בסלון</Title>
      <TextWithOpacity>ינואר 2020</TextWithOpacity>

      <P>ברוכים הבאים לאתר עמותת זיכרון בסלון.</P>
      <P>
        עמותת זיכרון בסלון מבקשת לאפשר וליצור שיח פתוח בנושא זיכרון השואה
        והשפעתו על החברה בעבר, בהווה ובעתיד, בין השאר באמצעות סיוע בארגון מפגשים
        ביתיים בין מארחים למתארחים (כהגדרתם מטה), חלקם בהשתתפות נותני עדות
        (כהגדרתם מטה) אשר יספרו לקהל אורחים וחברים את סיפורם וחוויתם מתקופת
        השואה. המפגשים מתקיימים במקומות שונים אצל מארחים מכל רחבי הארץ (ובארצות
        נוספות בעולם). באמצעות מפגשים אלה מבקשת זיכרון בסלון לכבד ולשמר את
        זיכרון השואה עבור דורות ההמשך.
      </P>
      <P>
        תקנון זה ("התקנון") מסדיר את היחסים בין נותני עדות, המארחים והמתארחים
        בפעילות זיכרון בסלון, לרבות גולשי האתר ("המשתתפים") ומפרט את הכללים על
        פיהם המשתתפים יכולים לקחת חלק בפעילות העמותה. תקנון זה מהווה חוזה מחייב
        בין המשתתפים לבין זיכרון בסלון. אנא קראו את התקנון בעיון רב שכן גלישה
        ו/או הרשמה ו/או כל שימוש אחר באתר יחשבו כהסכמה לכללים המפורטים בתקנון.
        תקנון זה מנוסח בלשון זכר מטעמי נוחות בלבד וההתייחסות הינה לשני המינים
        כאחד. בכל מקום בו מנוסח תוכן האתר בלשון יחיד ההתייחסות הינה ליחיד/רבים
        לפי העניין.
      </P>
      <P>
        אתרי האינטרנט{" "}
        {
          <a
            href="http://zikaronbasalon.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            zikaronbasalon.org
          </a>
        }{" "}
        ,{" "}
        {
          <a
            href="http://zikaronbasalon.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            zikaronbasalon.com
          </a>
        }{" "}
        ו-{" "}
        {
          <a
            href="http://zikaronbasalon.herokuapp.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            zikaronbasalon.herokuapp.com
          </a>
        }{" "}
        (להלן ביחד: "האתר") מופעלים על ידי עמותת זיכרון בסלון, עמותה רשומה מספר
        580662070, מרחוב פאת השולחן 4/11 תל אביב ו/או מי מטעמה (לעיל ולהלן:
        "זיכרון בסלון"). בכל שאלה או סוגיה בקשר לאתר ניתן לפנות למשרדי זיכרון
        בסלון באמצעות דוא"ל
        {
          <a
            href="mailto:info@zikaronbasalon.com"
            target="_self"
            data-content="info@zikaronbasalon.com"
            data-type="mail"
          >
            info@zikaronbasalon.com
          </a>
        }
        .
      </P>
      <P>
        בכל מקום בו מופיע בתקנון זה המונח "זיכרון בסלון" הכוונה היא זיכרון בסלון
        ו/או עובדיה ו/או נותני השירות שלה ו/או מי מטעמה, לפי העניין.
      </P>
      <P>
        גלישה ו/או שימוש על ידך באתר, מכל סוג, מהווה את הסכמתך ואישורך לאמור
        בתקנון זה והתחייבותך על פיו. זיכרון בסלון שומרת לעצמה את הזכות לעדכן
        ולתקן את הוראות התקנון ובכלל זה את תנאי השימוש מעת לעת, בכפוף לכל דין,
        לפי שיקול דעתה הבלעדי וללא צורך בהודעה מראש. תוקפו של כל עדכון או שינוי
        בתקנון זה לרבות תנאי השימוש הכלולים בו יחל מרגע פרסומו באתר אלא אם כן
        צוין אחרת. זיכרון בסלון תודיע על שינויים מהותיים בתקנון במקום בולט באתר.
        יחד עם זאת, מומלץ לעיין בתקנון זה מפעם לפעם על מנת להתעדכן ולוודא כי
        תנאיו ידועים לך. שימוש באתר על ידך מהווה הסכמה בלתי מותנית לתנאי תקנון
        זה ובכלל זה מדיניות הפרטיות, בכל כניסה לאתר. אם אינך מסכים לתנאי השימוש
        של האתר, כולם או חלקם, אזי אין לעשות שימוש באתר לכל מטרה שהיא, ולא תהיה
        לך כל טענה, תביעה ו/או דרישה כלפי זיכרון בסלון או מי מטעמה.
      </P>
      <P>
        אם הנך מתחת לגיל 18, אנא קרא תנאים אלה בעיון ובקפידה ביחד עם הוריך או
        אפוטרופוס אחר. אם אתה ו/או הוריך לא מסכימים לתנאי השימוש של האתר, כולם
        או חלקם, אזי אין לעשות שימוש באתר זה לכל מטרה שהיא, ולא תהיה לך כל טענה,
        תביעה ו/או דרישה כלפי זיכרון בסלון או מי מטעמה.
      </P>

      <ListMain>
        <li>
          <P>
            <LiTitle>הגדרות.</LiTitle>
          </P>
          <ListSec>
            <li>
              "נותן(י) עדות" – ניצול(י) שואה, אנשי דור שני לשואה, אנשי דור שלישי
              לשואה ומומחים בנושאי אקדמיה ורוח מתחום חקר השואה.
            </li>
            <li>"מארח" - מי שמבקש לארח מפגש של זיכרון בסלון.</li>
            <li>
              "מפגש" – אירוע בהשתתפות של מארח/ים, מתארחים, ולעיתים בשילוב נותן/י
              עדות.
            </li>
            <li>"מתארח" – מי שמבקש להשתתף במפגש.</li>
            <li>
              "גולש" - כל מי שגולש או עושה כל שימוש באתר, בין אם הוא מארח,
              מתארח, נותן עדות או אחר.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>שירותי האתר.</LiTitle>
          </P>
          <ListSec>
            <li>
              האתר מהווה פלטפורמה המסייעת בארגון פעילותה של זיכרון בסלון, ובין
              היתר בארגון המפגשים, המהווים ערבי זיכרון אינטימיים והוא משמש את
              המארחים, נותני העדות והמתארחים כאחד.
            </li>
            <li>
              בנוסף, האתר עשוי להכיל תכנים שונים אשר יועלו וישותפו בהתאם לשיקול
              דעת זיכרון בסלון או מי מטעמה, לרבות סרטים, הקלטות, עדויות בכתב,
              מסמכים שונים והפניות לאתרים אחרים.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>נותן העדות.</LiTitle>
          </P>
          <ListSec>
            <li>
              נותן עדות המעוניין לספר את סיפורו במפגש ימסור את הפרטים הבאים
              לנציג זיכרון בסלון ו/או יבצע רישום באמצעות האתר ויזין במקום המיועד
              לכך באתר את הפרטים הבאים: שם פרטי ושם משפחה, טלפון של נותן העדות,
              דואר אלקטרוני של נותן העדות, טלפון של איש קשר מטעם נותן העדות,
              דואר אלקטרוני של איש קשר מטעם נותן העדות, הקירבה של איש הקשר לנותן
              העדות, כתובת מגורים מלאה, התאריכים המתאימים למפגש, השפה בה ירצה
              נותן העדות לספר את סיפורו, דרישות נגישות (האם זקוק למעלית, רמקול
              או כל אביזר עזר אחר), ורקע קצר אודות סיפורו. יובהר כי עצם מסירת
              הפרטים אינה מחייבת את זיכרון בסלון לארגן מפגש ו/או להזמין את נותן
              העדות למפגש..
            </li>
            <li>
              אין לזיכרון בסלון כל אחריות לאמיתות ו/או תוכן הסיפור של נותן
              העדות, והוא מושתת אך ורק על זכרונו של נותן העדות.
            </li>
            <li>
              ככל ונותן העדות מוסר את פרטיו באתר (או בכל דרך אחרת) באמצעות צד
              שלישי אשר אינו נציג זיכרון בסלון ("המפנה"), המפנה מצהיר ומאשר כי
              קיבל את הסכמתו המפורשת מראש של נותן העדות למסור את פרטיו לזיכרון
              בסלון, ותנאי תקנון זה יחולו על נותן העדות ועל המפנה ביחד ולחוד..
            </li>
            <li>
              "נותן העדות אחראי להגיע למפגש במועד ובמקום כפי שתואמו עמו, ולהודיע
              לזיכרון בסלון וכן למארח בהקדם האפשרי על כל עיכוב או נסיבות אחרות
              המונעות ממנו להשתתף במפגש. אין לזיכרון בסלון כל אחריות ו/או
              התחייבות בקשר עם הגעתו של נותן העדות לבית המארח ו/או בקשר עם מצבו
              האישי או הבריאותי של נותן העדות.
            </li>
            <li>נותן העדות יגיע למפגש וישתתף בו בהסכמה ומרצונו החופשי.</li>
            <li>
              נותן העדות מצהיר כי אין מניעה חוקית, חוזית או אחרת להשתתף במפגש,
              וכי כל הפרטים שנמסרו על ידו לזיכרון בסלון באמצעות האתר (או בכל דרך
              אחרת) הינם נכונים ומדויקים.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>מארח.</LiTitle>
          </P>
          <ListSec>
            <li>
              מארח המעוניין לארח מפגש יכול לבצע רישום באמצעות האתר ובהתאם יזין
              במקום המיועד לכך באתר את הפרטים הבאים: שם פרטי ושם משפחה, טלפון,
              דואר אלקטרוני, שפות אותן דובר המארח, כתובת מגורים וקומה, פרטים
              אודות רמת הנגישות (האם יש מעלית, מדרגות בכניסה לבית וכו'), המועדים
              הרצויים והזמנים הרצויים לאירוח, מספר האנשים המינימלי והמקסימלי
              אותו אפשר לארח וכל פרט נוסף הרלבנטי לתיאום המפגש. יובהר כי עצם
              מסירת הפרטים אינה מחייבת את זיכרון בסלון לפעול לתיאום מפגש עם
              המארח.
            </li>
            <li>
              זיכרון בסלון רשאית, אך אינה חייבת, לסייע בתיאום בין מארחים ובין
              נותני עדות לטובת ארגון המפגשים.
            </li>
            <li>
              מארח לא יסרב סירוב בלתי סביר לארח במפגש כל נותן עדות ו/או מתארח.
            </li>
            <li>
              המארח מסכים כי שמו הפרטי וכתובתו (עיר ושם רחוב) יפורסמו באתר לצורך
              תיאום המפגשים. המארח יכול לבחור לשתף את פרטי המפגש אותו הוא מארח
              ברשתות החברתיות על ידי שימוש בקישור לאתר זיכרון בסלון.{" "}
            </li>
            <li>
              המארח יכול לבחור לסגור את ההרשמה למפגש אצלו, ולא לאפשר למתארחים
              נוספים להירשם למפגש כאמור.
            </li>
            <li>
              לצורך ביטול מפגש ישלח המארח בקשת ביטול לזיכרון בסלון על ידי פנייה
              בכתב לדוא"ל info@zikaronbasalon.com.
            </li>
            <li>
              המארח יהא אחראי באופן בלעדי להודיע לנותן העדות ומתארחים אשר נרשמו
              למפגש אודות ביטול המפגש ו/או אודות כל שינוי בפרטי המפגש, בהקדם
              האפשרי.
            </li>
            <li>
              המארח מצהיר כי אין לו מניעה חוקית, חוזית או אחרת לארח את המפגש
              בביתו וכי כל הפרטים שנמסרו על ידו לזיכרון בסלון באתר (או בכל דרך
              אחרת) הינם נכונים ומדויקים.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>מתארח.</LiTitle>
          </P>
          <ListSec>
            <li>
              מתארח אשר מעוניין לקבל דיווח היכן מתקיים מפגש יכול לבצע רישום
              באמצעות האתר ויזין במקום המיועד לכך באתר את הפרטים הבאים: שם פרטי
              ושם משפחה, טלפון, דואר אלקטרוני, מען, המקום המועדף להתארח, השפה בה
              ירצה לשמוע את סיפור נותן העדות ובקשות נגישות ככל שישנן. יובהר כי
              עצם מסירת הפרטים על ידי המתארח אינה מחייבת את זיכרון בסלון ו/או
              המארחים להזמין את המתארח למפגשים.
            </li>
            <li>
              לצורך השתתפות במפגשים, המתארח ישלח באמצעות האתר בקשה להתארח.
              זיכרון בסלון אינה מתחייבת להיענות לבקשות כאמור, כולן או חלקן,
              ולמתארח לא תהיה כל טענה בגין כך.
            </li>
            <li>
              המתארח יכבד את המארח ויתר המשתתפים ואת מקום האירוח, ולא יפריע בעת
              מתן העדות.
            </li>
            <li>
              המתארח אחראי להגיע למפגש אליו נרשם, ולהודיע לזיכרון בסלון וכן
              למארח בהקדם האפשרי ככל ואינו מתכוון להגיע להשתתף במפגש.
            </li>
            <li>
              המתארח מצהיר כי אין לו מניעה חוקית, חוזית או אחרת להשתתף במפגש וכי
              כל הפרטים שנמסרו על ידו לזיכרון בסלון באתר (או בכל דרך אחרת) הינם
              נכונים ומדויקים.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>השתתפות ללא עלות.</LiTitle>{" "}
            <LiTextBold>
              יובהר כי נותן העדות והמארח מבצעים את תפקידם בהתנדבות וללא שכר, כי
              המפגשים הינם ללא עלות למשתתפים, וכי לא ניתן לגבות כסף עבור אירוח
              ו/או מתן עדות במפגשים.
            </LiTextBold>
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>נכונות הפרטים.</LiTitle> המשתתפים מתחייבים להזין לאתר פרטים
            נכונים, עדכניים ואמיתיים בלבד. יחד עם זאת, לזיכרון בסלון אין כל
            אחריות למילוי שגוי של פרטי משתתפים ולא תהיה למי מהמשתתפים בשל כך כל
            טענה ו/או דרישה כלפי זיכרון בסלון או מי מטעמה. ככל שזיכרון בסלון
            תגלה כי משתתף הזין פרטים שגויים, היא רשאית למחוק את פרטי המשתתף מן
            האתר לאלתר ולאסור על השתתפותו במפגשים ו/או על השימוש באתר.
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>פרסום הפרטים.</LiTitle> פרטי המפגשים (שמו הפרטי של המארח,
            עיר ושם הרחוב) יהיו גלויים באתר וזאת על מנת שכל גולש יוכל לבחור האם
            ברצונו להשתתף במפגשים.
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>שמירת פרטיות.</LiTitle> לפני ובמהלך המפגשים, המשתתפים
            עשויים להיחשף לפרטים אישיים אודות משתתפים אחרים, ובפרט לפרטיהם של
            אנשי עדות ומארחים. מדובר במידע אשר נחשף על ידי המשתתפים האחרים באופן
            עצמאי ומבחירה, וזיכרון בסלון אינה אחראית לעצם חשיפתו או לשימוש
            שייעשה במידע כאמור על ידי מי מהמשתתפים. בעצם ההשתתפות במפגשים
            מתחייבים המשתתפים שלא לעשות כל שימוש בפרטים אשר נחשפו בפניהם, פרט
            לשימוש לצורך תיאום המפגשים והוצאתם לפועל, ולא להעבירם לכל צד שלישי
            ללא הסכמת המשתתף מגלה המידע מראש.
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>פרסום פרטי משתתפים.</LiTitle>
          </P>
          <ListSec>
            <li>
              זיכרון בסלון רשאית לצלם את המפגשים ולהעלות אותם לאתר ו/או לכל מדיה
              אחרת לפי שיקול דעתה של זיכרון בסלון, ולא תהיה בשל כך כל טענה מצד
              מי מהמשתתפים. ככל ומשתתף אינו מעוניין בפרסום תמונתו או פרטיו, יפנה
              המשתתף לזיכרון בסלון מראש ובכתב בבקשה להסתיר/ לטשטש את תמונתו ו/או
              פרטיו האחרים.{" "}
            </li>
            <li>
              המשתתפים מסכימים כי תמונות ו/או סרטוני וידאו ככל שיצולמו במפגשים
              יפורסמו באתר ו/או בפרסומים מטעם זיכרון בסלון מבכל סוג שהוא ובכל
              מדיה שהיא, וכי המשתתפים לא יהיו זכאים לכל תמורה בגין כך.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>מאגר מידע.</LiTitle> יובהר כי בעת רישום לאתר, פרטיך יישמרו
            אוטומטית במאגר המידע של זיכרון בסלון ("מאגר המידע") והרשמתך לאתר
            מהווה הסכמתך לכך. יובהר כי אם אינך מעוניין להיכלל במאגר המידע של
            זיכרון בסלון, זיכרון בסלון לא תוכל לשבץ אותך במפגשים. המידע יישמר
            במאגר המידע כל עוד הוא דרוש למימוש מטרות מאגר המידע.
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>קבלת הודעות.</LiTitle> עם הרישום לאתר, יתבקשו המשתתפים לתת
            את הסכמתם המפורשת לקבלת הודעות, לרבות שאלונים אשר יישלחו מעת לעת על
            מנת לשפר ולייעל את פעילות של זיכרון בסלון, דואר אלקטרוני, דואר רגיל,
            הודעות טקסט ושיחות טלפון מזיכרון בסלון או מי מטעמה. כמו כן, המשתתפים
            מאשרים קבלת הודעות בעלות אופי שיווקי ו/או מסחרי מאת זיכרון בסלון
            באמצעים אלקטרוניים. ניתן בכל שלב לבקש את ההסרה מרשימת התפוצה של
            זיכרון בסלון, על ידי פנייה בכתב לדוא"ל{" "}
            <a
              href="mailto:info@zikaronbasalon.com"
              target="_self"
              data-content="info@zikaronbasalon.com"
              data-type="mail"
            >
              info@zikaronbasalon.com
            </a>{" "}
            אשר תטופל בתוך ארבעה עשר (14) ימי עסקים.
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>קניין רוחני.</LiTitle>
          </P>
          <ListSec>
            <li>
              כל הנתונים, העיצובים והמידע המצויים באתר, למעט מידע המצוי בקישורים
              לאתרים האחרים שהאתר מפנה ו/או יכול להפנות אליהם ("תוכן האתר"), הם
              קניינה הבלעדי של זיכרון בסלון ואין לראות במידע ו/או בשירותים ככל
              ומסופקים על ידה באתר כמקנים רישיון כלשהו או זכויות כלשהן בתוכן
              האתר ו/או בזכויות הקניין הרוחני של זיכרון בסלון או של צדדים
              שלישיים, לפי העניין. "זכויות קניין רוחני" בתקנון זה משמען זכויות
              מכל סוג שהוא בתוכן האתר, ברעיון העומד ביסוד האתר, לרבות זכויות
              יוצרים, קוד מחשב, ממשקי משתמש, סימנים מסחריים, עיצובים, מדגמים,
              שמות מסחריים ושמות עסק, ידע ומידע, שיטות, תוכניות, טכנולוגיה, מידע
              טכני, מידע עסקי, סודות מסחריים וכן כל זכות המקבילה ו/או הנגזרת מכל
              אחד מן האמורים לעיל, בין אם רשומה ובין אם לאו, בארץ ובעולם. זכויות
              הקניין הרוחני הינן בבעלות הייחודית והבלעדית של זיכרון בסלון. אין
              להעתיק או לפרסם את תוכן האתר במלואו או בחלקו ו/או לעשות בהם או
              במידע שבתוכם שימוש כלשהו, לרבות שימוש מסחרי, ללא הסכמתה המפורשת
              מראש ובכתב של זיכרון בסלון. כמו כן, אין להכניס באתר שינויים,
              להעתיק, להפיץ, לשדר, להציג בפומבי, לשכפל, לפרסם או למסור לצד שלישי
              כל חלק מתוכן האתר בלא קבלת הסכמתו של זיכרון בסלון מראש ובכתב.
            </li>
            <li>
              פרסומת המוצגת באתר מטעם גורם שאינו זיכרון בסלון הינה קניינו של
              המפרסם ובאחריותו הבלעדית, ואין לעשות בה שימוש הפוגע בזכות המפרסם.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>הגבלת אחריות.</LiTitle>
          </P>
          <ListSec>
            <li>
              יכרון בסלון אינה אחראית לכל עיכוב במפגש או לביטול מפגש מכל סיבה
              שהיא, ואינה מתחייבת להודיע על ביטול או עיכוב כאמור למי מהמשתתפים.
              כמו כן זיכרון בסלון אינה אחראית לנוחות ו/או לנגישות ו/או לתנאים
              אחרים במקום המפגש, להיקף או מהות התכנים שיעלו במפגש, לזהות
              המשתתפים במפגש, לאופי המפגש ו/או הדיון במפגש ככל שיתפתח. למשתתפים
              או מי מטעמם אין ולא תהיה כל טענה ו/או תביעה ו/או דרישה בקשר לכל
              האמור לעיל כנגד זיכרון לסלון. כמו כן, אין לזיכרון בסלון כל אחריות
              לכל נזק, ישיר או עקיף או לכל פגיעה כלשהי ככל שייגרמו למי מהמשתתפים
              בזמן המפגש מכל סיבה שהיא ולא תהיה כתוצאה מכך למי מהמשתתפים או
              לצדדים שלישיים כל תביעה ו/או טענה כנגד זיכרון בסלון או מי מטעמה.
            </li>
            <li>
              המידע המוצג באתר מופיע כמות שהוא (AS IS) כפי שמתקבל מהמשתתפים או
              מגורמים אחרים. זיכרון בסלון אינה ולא תהיה אחראית, באופן ישיר או
              עקיף, למידת הדיוק, אמיתות ומהימנות של מידע כפי שהתקבל מן המשתתפים
              או כל צד שלישי. הסתמכות על תוכן האתר הינה באחריות המלאה של
              הגולשים.
            </li>
            <li>
              השימוש באתר ובשירותים המוצעים בו הינו על פי שיקול דעתך ובאחריותך
              בלבד. השימוש באתר ובתכנים ניתן לך חינם כמות שהוא (AS IS) בהתאם
              להחלטת זיכרון בסלון, ולא תהיה לך כל טענה, תביעה או דרישה כלפי
              זיכרון בסלון או מי מטעמה בגין תכונות השימוש או השירות, יכולותיו
              ומגבלותיו, התאמתו לצרכיך או התגובות שיעורר (אם בכלל) הפרסום, אם
              וככל שיהיה, באתר.
            </li>
            <li>
              זיכרון בסלון תעשה ככל שביכולתה כדי להבטיח את תקינות האתר. על אף
              האמור, זיכרון בסלון אינה מתחייבת ששירותי האתר יינתנו כסדרם או בלא
              הפסקות, יתקיימו בבטחה ו/או הפרעות ויהיו חסינים מפני גישה
              בלתי-מורשית למחשבי ו/או לתוכנות זיכרון בסלון או מפני נזקים,
              קלקולים, תקלות או כשלים, בין היתר בחומרה, בתוכנה, בקווי ובמערכות
              תקשורת, אצל זיכרון בסלון או אצל מי מספקיה או אצלך, ולא תהיה לך כל
              טענה כלפי זיכרון בסלון ו/או לנותני השירות של זיכרון בסלון בקשר
              לכך. הנך מודע לכך כי ייתכן ובעתיד לא יהיה השירות זמין בשל תחזוקה,
              שדרוג או מכל סיבה אחרת.
            </li>
            <li>
              זיכרון בסלון תעשה ככל שביכולתה כדי להבטיח כי כל הקישורים שימצאו
              באתר יהיו תקינים ויובילו את הגולשים לאתר אינטרנט פעיל. על אף האמור
              אין זיכרון בסלון אחראית לקישור לא פעיל או לא תקין או שאינו מאובטח
              כנדרש. זיכרון בסלון רשאית בכל עת למחוק מהאתר קישורים שנכללו בו
              בעבר, או להימנע מהוספת קישורים חדשים - הכל לפי שיקול דעתה הבלעדי.
              עצם קיומו של קישור לאתר חיצוני מסוים בתוך האתר אינה מהווה אישור
              לכך שהמידע באתר חיצוני זה מלא, אמין, עדכני או מהימן.
            </li>
            <li>
              זיכרון בסלון תהיה רשאית בכל עת להשבית את האתר ו/או לשנות מעת לעת
              את מבנהו, מראהו, אופן תפעולו וזמינותם של השירותים והמוצרים המוצעים
              בו (ככל ומוצעים) וזאת ללא צורך להודיע לגולשים על כך. שימוש באתר
              לאחר שינוי או עדכון כלשהו בתנאי השימוש של האתר מהווה את הסכמתך
              לתנאי האתר המעודכנים. בכל מקרה, למשתתפים לא תהא כל טענה או דרישה
              כלפי זיכרון בסלון בקשר עם זמינות האתר, תוכן האתר, וביצוע שינויים
              או עדכונים כאמור בסעיף זה.
            </li>
            <li>
              השימוש באתר כפוף לכל החוקים והתקנות המקומיים, מדינתיים
              והבינלאומיים הרלבנטיים והמשתתפים מתחייבים לפעול על פי כל דין בקשר
              עם השימוש באתר ובשירותיו ולעשות שימוש חוקי, סביר והוגן בלבד באתר.
            </li>
          </ListSec>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>פרסומות של צדדים שלישיים, קישורים לאתרים אחרים.</LiTitle>{" "}
            האתר עשוי להכיל מעת לעת קישורים לאתרים חיצוניים אשר אינם קשורים או
            שייכים לזיכרון בסלון (להלן: "אתרים חיצוניים"). זיכרון בסלון אינה
            אחראית לתקינות ו/או לתוכן של האתרים החיצוניים, ו/או לשימוש באתרים
            החיצוניים ואין ולא תהיה לה אחריות, שליטה או אפשרות פיקוח על התכנים
            המצויים באתרים החיצוניים, ו/או על מדיניות הפרטיות של האתרים
            החיצוניים ואין בהימצאות הקישורים באתר משום המלצה של זיכרון בסלון
            לבקר בהם. ביקורך באתרים האחרים הינו לפי שיקול דעתך ועל אחריותך בלבד.
          </P>
        </li>
      </ListMain>

      <ListMain>
        <li>
          <P>
            <LiTitle>שונות.</LiTitle>
          </P>
          <ListSec>
            <li>
              זיכרון בסלון אינה מפלה על בסיס גיל, מין, גזע, מוצא, לאום, דת,
              העדפה מינית או כל סטאטוס אחר.
            </li>
            <li>
              זיכרון בסלון שומרת לעצמה את הזכות לבטל או לסרב קיום מפגש, וזאת על
              פי שיקול דעתה הבלעדי.
            </li>
            <li>
              יכרון בסלון רשאית להמחות ו/או להעביר ו/או להסב את זכויותיה לפי
              תקנון זה, או חלק מהן, לכל תאגיד או גוף צד שלישי לפי שיקול דעתה
              הבלעדי וללא צורך להודיע על כך מראש.
            </li>
            <li>
              על תקנון זה אלו יחולו דיני מדינת ישראל. מקום השיפוט הבלעדי לכל
              עניין הנוגע לתקנון זה ולשימוש באתר הינו בבתי המשפט המוסמכים באזור
              תל-אביב יפו.
            </li>
            <li>
              אם תנאי מתנאי תקנון זה ימצא בלתי חוקי, בטל או בלתי אכיף מכל סיבה,
              תנאי זה יימחק מן התקנון ומחיקתו לא תשפיע על חוקיות ותקפות יתר תנאי
              התקנון.
            </li>
          </ListSec>
        </li>
      </ListMain>
    </TermsContainer>
  );
};

export default PolicyTermsHeb;
